var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('toggle-button',{attrs:{"value":_vm.value,"sync":true,"color":{checked: _vm.switchBtnActiveColor, unchecked: _vm.switchBtnInActiveColor},"labels":{checked: 'ON', unchecked: 'OFF' }},on:{"change":_vm.onChange}})}
var staticRenderFns = []

export { render, staticRenderFns }